/**
 * Backbone view which provides editor functionality for a 'color' field type.
 * ## Fields
 * The `value` field gets and sets the current value.
 * ## Events
 * The `'change'` event is raised whenever the value changes. The event has a single argument, the new value.
 * @module app/Field/ColorEditor
 */
import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
import $ from "jquery";
import "bootstrap-colorpicker";
var FORMAT = "rgba";
var Color = $.colorpicker.Color.prototype;

export default BaseFieldView.extend({
  className: "input-group",
  template: _.template(
    '<span class="input-group-addon"><i></i></span><input type="text" value="" <%-manualEntry ? \'\' : \'readonly="readonly"\'%> class="form-control"/>'
  ),

  getControlValue: function () {
    var color = new $.colorpicker.Color(this.$el.data("color"));

    return color.toString(FORMAT);
  },

  setControlValue: function (value) {
    var parsedValue = value;

    if (_.isString(value)) {
      parsedValue = Color.stringToHSB(value);
    } else if (_.isObject(value)) {
      parsedValue = Color.RGBtoHSB(value.r, value.g, value.b, value.a);
    }

    var color = new $.colorpicker.Color(parsedValue);

    this.$("input").val(color.toString(FORMAT));

    try {
      this.$el.colorpicker("setValue", color.toString());
    } catch (err) {
      //do nothing
      //todo somehow destroy or unregister editor views that have been removed from the DOM?
    }
  },

  serialize: function (items) {
    items = BaseFieldView.prototype.serialize.call(this, items);

    return _.extend({}, items, {
      manualEntry: !!items.manualEntry,
    });
  },

  postRender: function () {
    if (this.$el.data("colorpicker")) {
      this.$el.colorpicker("destroy");
    }
    this.$el.colorpicker(
      _.extend(
        {
          format: FORMAT,
        },
        _.omit(this.options, "context", "field", "model")
      )
    );
    this.$el.colorpicker().on(
      "changeColor",
      _.bind(function () {
        this.onChange();
      }, this)
    );
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/edit/ColorEditor.js
// module id = 839
// module chunks = 1